import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SelectOption {
  value: string,
  label: string,
}

interface AppContextReducer {
  isLoading: boolean
  defaultFormData: {
    stateSelect: SelectOption[]
    citySelect: SelectOption[]
  }
  currentTerms: {
    id: string
    version: string
    content: string
  }
}

const initialState: AppContextReducer = {
  isLoading: false,
  defaultFormData: {
    stateSelect: [],
    citySelect: [],
  },
  currentTerms: {
    id: '',
    version: '',
    content: '',
  },
}

const appContextSlice = createSlice({
  name: 'appContext',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setStateOptions: (state, action: PayloadAction<SelectOption[]>) => {
      state.defaultFormData.stateSelect = action.payload
    },
    setCityOptions: (state, action: PayloadAction<SelectOption[]>) => {
      state.defaultFormData.citySelect = action.payload
    },
    setCurrentTerms: (state, action: PayloadAction<AppContextReducer['currentTerms']>) => {
      state.currentTerms = action.payload
    },
  },
})

export const {
  setIsLoading,
  setStateOptions,
  setCityOptions,
  setCurrentTerms,
} = appContextSlice.actions

export default appContextSlice.reducer
